import { useEffect, useRef } from "react";

interface CanvasIframeProps {
  src: string; // URL of the canvas app page
  config?: any; // Optional config you want to pass
  width?: string | number;
  height?: string | number;
}

const CanvasIframe = ({
  src,
  config,
  width = "100%",
  height = "100%",
}: CanvasIframeProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  // Optional: send config to iframe via postMessage after load
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe || !config) return;

    const handleLoad = () => {
      iframe.contentWindow?.postMessage(
        { type: "SET_CONFIG", config },
        window.location.origin
      );
    };

    iframe.addEventListener("load", handleLoad);

    return () => {
      iframe.removeEventListener("load", handleLoad);
    };
  }, [config]);

  return (
    <iframe
      ref={iframeRef}
      src={src}
      style={{ border: "none", width, height }}
      title="Canvas App"
    />
  );
};

export default CanvasIframe;
